import { getField, updateField } from 'vuex-map-fields'
import BaseStore from './baseStore'
import api from '../api/api'
import { generateMultipleItemOverview } from '@/store/baseOverview'

export const namespaced = true

const baseUrl = '/soil_types/'

const baseStore = new BaseStore(baseUrl)
const baseOverview = generateMultipleItemOverview({
  itemFilter: (soilType, soilTypeRevisionId) => soilType.soil_type_revision === soilTypeRevisionId,
  duplicationCheckFunc: (soilType, soilTypeRevisionId) =>
    soilType.soil_type_revision === soilTypeRevisionId
})

const getDefaultState = () => ({
  ...structuredClone(baseStore.state),
  ...structuredClone(baseOverview.state),
  dialog: false,
  status: 'empty',
  uploadLoading: false,
  importLoading: false,
  importItems: [],
  downloadLoading: false,
  exportLoading: false,
  templateFileName: 'soil_types_template.xlsx'
})
export const state = getDefaultState()

export const mutations = {
  ...baseStore.mutations,
  ...baseOverview.mutations,
  TOGGLE_UPLOAD_LOADING(state) {
    state.uploadLoading = !state.uploadLoading
  },
  TOGGLE_IMPORT_LOADING(state) {
    state.importLoading = !state.importLoading
  },
  TOGGLE_DOWNLOAD_LOADING(state) {
    state.downloadLoading = !state.downloadLoading
  },
  TOGGLE_EXPORT_LOADING(state) {
    state.exportLoading = !state.exportLoading
  },
  ADD_IMPORT_ITEMS(state, items) {
    state.importItems = items
  },
  RESET_STATE(state) {
    Object.assign(state, getDefaultState())
  },
  RESET_DIRTY_ITEMS(state) {
    state.items = state.items.filter((item) => !state.dirtyItems.includes(item))
    state.dirtyItems = []
  },
  RESET_IMPORT_STATE(state) {
    state.importItems = []
  },
  RESET_OVERVIEW_STATE(state) {
    state.itemsOverview = []
  },
  TOGGLE_WRITE_LOADING(state) {
    state.writeLoading = !state.writeLoading
  },
  DELETE_ITEMS(state, items) {
    state.items = state.items.filter((item) => !items.includes(item))
  },
  updateField
}
export const actions = {
  ...baseStore.actions,
  ...baseOverview.actions,
  resetState({ commit }) {
    commit('RESET_STATE')
  },
  resetDirtyItems({ commit }) {
    commit('RESET_DIRTY_ITEMS')
  },
  resetImportState({ commit }) {
    commit('RESET_IMPORT_STATE')
  },
  resetOverviewItems({ commit }) {
    commit('RESET_OVERVIEW_STATE')
  },
  async add(context, id) {
    const selectedRevision = context.rootGetters['project/selectedSoilTypeRevision'].id
    const item = context.getters.getEmptySoilType(selectedRevision, id)
    context.commit('ADD_ITEM', item)
    context.commit('ADD_COUNT', 1)
  },
  async fetchItemsAdd(context, id) {
    const currentSoilTypes = context.state.items.filter((item) => item.soil_type_revision === id)
    let url = context.state.baseUrl + `?search=${id}`
    let response = await api.get(url)
    context.commit('DELETE_ITEMS', currentSoilTypes)
    context.commit('ADD_ITEMS', response.data)
  }
}

export const getters = {
  getField,
  getItemsByRevision: (state, getters) => (revisionId) => {
    //getItemsByStabSchematisationStage has been renamed to getItemsByRevision
    //because they use the same logic but different purpose
    return getters.getItemsByStabSchematisationStage(revisionId)
  },
  getEmptySoilType: (state) => (revision, id) => {
    const emptyObj = {}
    Object.keys(state.options).forEach((key) => {
      let value = ''
      if (state.options[key].default !== undefined) {
        value = state.options[key].default
      } else if (state.options[key].type === 'float') {
        value = null
      }
      emptyObj[key] = value
    })

    emptyObj.soil_type_revision = revision
    emptyObj.id = id
    emptyObj.base_soil_type = id
    return emptyObj
  },
  getSoilTypeById:
    ({ itemsOverview }) =>
    (id) => {
      return itemsOverview.find((item) => item.id === id) || {}
    },
  getExportFileName: (state, getters, rootState, rootGetters) => {
    const projectName = rootState['project'].currentProject?.name
    const selectedRevisionNumber = rootGetters['project/selectedRevision']?.number
    return projectName + '_revision' + selectedRevisionNumber + '_SoilTypes_export.xlsx'
  },
  getSoilTypeByBaseSoilTypeId: (state) => (baseSoilTypeId) => {
    return state.items.find((item) => item.base_soil_type === baseSoilTypeId)
  },
  getSoilTypeBySelectedRevision: (state, getters, rootState, rootGetters) => {
    const selectedRevision = rootGetters['project/selectedSoilTypeRevision']
    return state.items.filter((item) => item.soil_type_revision === selectedRevision.id)
  }
}
